export const MAX_RECONNECT_ATTEMPTS = 8;
export const BACKOFF_BASE_SETTINGS = {min: 100, max: 30_000, jitter: 0.2};
